'use client';

import {usePathname, useRouter} from 'next/navigation';
import {useEffect} from 'react';

import Illustration from '@web-catalog/assets/icons/Illustration_web.svg';

import {useFilters} from '@web-catalog/hooks/useFilters';

import {logTmrEvent} from '@web-catalog/utils/analytics';

import styles from './NotFoundFiltered.module.scss';

type Props = {
  filter: string | null;
};

export const NotFoundFiltered = ({filter}: Props) => {
  const {filterBy, getFullValue} = useFilters();
  const pathname = usePathname();
  const router = useRouter();
  const isPaid = filter === 'paid';

  const onClick = () => {
    const newFilter = isPaid ? 'free' : 'paid';
    filterBy.set(newFilter);
    router.push(pathname + getFullValue());
    logTmrEvent({
      logEvent: 'noAppsMatchFilter.click',
      params: {
        button_text: `Смотреть ${isPaid ? 'бесплатные' : 'платные'}`,
        filter: newFilter,
      },
    });
  };

  useEffect(() => {
    logTmrEvent({logEvent: 'noAppsMatchFilter.show', params: {filter}});
  }, []);

  return (
    <div className={styles.wrapper}>
      <Illustration />
      <h1 className={styles.h1}>
        Среди {isPaid ? 'платных' : 'бесплатных'} ничего не нашлось
      </h1>
      <h2 className={styles.h2}>
        Попробуйте поискать среди {isPaid ? 'бесплатных' : 'платных'}
      </h2>
      <button className={styles.btn} onClick={onClick}>
        Смотреть {isPaid ? 'бесплатные' : 'платные'}
      </button>
    </div>
  );
};
